// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  inputSeq: __t.u32(),
  moveX: __t.f32(),
  moveZ: __t.f32(),
  jump: __t.bool(),
  yaw: __t.f32(),
  steps: __t.u8(),
  mode: __t.u8(),
};
